import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api } from '../utils/api';

export default function ForgotPassword() {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            // In api.js we will add forgotPassword endpoint
            await api.request('/auth/forgot-password', {
                method: 'POST',
                body: JSON.stringify({ email })
            });
            setSuccess(true);
        } catch (err) {
            setError(err.message || t('auth.requestFailed', 'Failed to request password reset.'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ minHeight: '100vh', background: 'var(--bg-base)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem 1.5rem', fontFamily: "'Roboto', sans-serif", position: 'relative', overflow: 'hidden' }}>

            {/* Background glow */}
            <div style={{ position: 'absolute', top: '30%', left: '50%', transform: 'translate(-50%, -50%)', width: '600px', height: '600px', borderRadius: '50%', background: 'radial-gradient(circle, var(--orange-glow) 0%, transparent 70%)', pointerEvents: 'none' }} />

            <div style={{ width: '100%', maxWidth: '440px', position: 'relative', zIndex: 1 }}>

                <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
                    <h1 style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '2.5rem', letterSpacing: '0.08em', color: '#ffffff', marginBottom: '0.4rem' }}>
                        {t('auth.forgotPassword', 'Forgot Password')}
                    </h1>
                    <div style={{ width: '40px', height: '3px', background: 'var(--orange)', borderRadius: '2px', margin: '0 auto 0.75rem' }} />
                    <p style={{ fontSize: '0.88rem', color: 'var(--text-muted)' }}>
                        {t('auth.forgotPasswordSubtitle', 'Enter your email to receive a reset link.')}
                    </p>
                </div>

                <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: '12px', padding: '2.5rem', position: 'relative', overflow: 'hidden' }}>
                    <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '3px', background: 'linear-gradient(90deg, var(--orange-dark), var(--orange), var(--orange-light))' }} />

                    {error && (
                        <div style={{ marginBottom: '1.25rem', padding: '0.85rem 1rem', background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: '6px', color: '#fca5a5', fontSize: '0.85rem' }}>
                            {error}
                        </div>
                    )}
                    {success && (
                        <div style={{ marginBottom: '1.25rem', padding: '0.85rem 1rem', background: 'rgba(34, 197, 94, 0.08)', border: '1px solid rgba(34, 197, 94, 0.3)', borderRadius: '6px', color: '#86efac', fontSize: '0.85rem' }}>
                            {t('auth.resetLinkSent', 'If your email is in our system, a reset link will be sent shortly.')}
                        </div>
                    )}

                    {!success && (
                        <form onSubmit={handleSubmit}>
                            <label style={{ display: 'block', fontFamily: "'Oswald', sans-serif", fontSize: '0.72rem', fontWeight: 600, letterSpacing: '0.15em', textTransform: 'uppercase', color: 'var(--text-muted)', marginBottom: '0.5rem' }}>
                                {t('auth.email', 'Email')}
                            </label>
                            <input
                                id="email"
                                type="email"
                                placeholder={t('auth.placeholderEmail', 'name@example.com')}
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                required
                                className="barber-input"
                                style={{ marginBottom: '2rem' }}
                            />

                            <button
                                type="submit"
                                disabled={loading}
                                className="btn-orange"
                                style={{ width: '100%', justifyContent: 'center', fontSize: '0.95rem', padding: '0.9rem', opacity: loading ? 0.6 : 1, cursor: loading ? 'not-allowed' : 'pointer' }}
                            >
                                {loading ? t('common.loading', 'Loading...') : t('auth.sendResetLink', 'Send Reset Link')}
                            </button>
                        </form>
                    )}
                </div>

                <p style={{ textAlign: 'center', fontSize: '0.85rem', marginTop: '1.5rem' }}>
                    <Link to="/login" style={{ color: 'var(--orange)', textDecoration: 'none', fontWeight: 600, fontFamily: "'Oswald', sans-serif", letterSpacing: '0.05em' }}>
                        {t('auth.backToLogin', 'Back to Login')}
                    </Link>
                </p>
            </div>
        </div>
    );
}
